/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerCreatedBy } from './card-transactions-merged-transaction-detail-list-inner-evidence-list-inner-created-by';
// May contain unused imports in some cases
// @ts-ignore
import { CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrors } from './card-transactions-merged-transaction-detail-list-inner-evidence-list-inner-errors';
// May contain unused imports in some cases
// @ts-ignore
import { CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer } from './card-transactions-merged-transaction-detail-list-inner-evidence-list-inner-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy } from './card-transactions-merged-transaction-detail-list-inner-evidence-list-inner-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerUploadedBy } from './card-transactions-merged-transaction-detail-list-inner-evidence-list-inner-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarnings } from './card-transactions-merged-transaction-detail-list-inner-evidence-list-inner-warnings';

/**
 * 
 * @export
 * @interface CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
 */
export interface CardTransactionsMergedTransactionDetailListInnerEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentType': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'electronicMethod': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'documentSize': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'legalValidity': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'invoiceIssuer': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpiError': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'detectedDpiError': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'calculatedDpiError': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'colorGradationError': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'heightMillisError': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'widthMillisError': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrors}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'errors': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerErrors;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarnings}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'warnings': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWarnings;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerCreatedBy}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'createdBy': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedBy': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerUploadedBy}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedBy': CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionsMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedFrom': string;
}

export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum];
export const CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum[keyof typeof CardTransactionsMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum];


